/**
 * Overrides for @fe-toolkit/web-components' default theme.
 *
 * `theme.layout.maxWidth` ships as 1140px; this repo's pages use 1440px instead.
 * Passed to every `ThemeProvider` (production, error boundary, Storybook, tests)
 * so `useTheme()` reports the same value everywhere.
 */
export const customTheme = {
  layout: {
    maxWidth: '1440px',
  },
}
